<template>
    <div class="content">
      <div class="trips-filters">
        <div class="filter-block">
          <div class="field">   
            <!-- Номер рейса -->
            <input type="text" placeholder="Номер заявки" v-model="filters.selectNumber" @keydown.enter="sendForm">
          </div>
          <div class="field">
             <!-- Опоздание на погрузку/выгрузку -->
            <select class="select-status" id="tmsStatus" v-model="filters.belated">
                <option value="">Опоздание</option>
                <option value="in_load">На погрузку</option>
                <option value="in_unload">На выгрузку</option>
            </select>
         </div>
        </div>

        <div class="filter-block">
            <div class="field">
              <!-- Менеджер -->
              <input type="text" id="managers" list="managerList" v-model="filters.selectedManager" placeholder="Менеджер" @keydown.enter="sendForm">
              <datalist id="managerList">
                <option v-for="manager in options.managers" :key="manager.id" :value="manager.name">{{ manager.name }}</option>
              </datalist>
          </div>
  
          <!-- Статус из ТМС -->
          <div class="field">
              <select class="select-status" id="tmsStatus" v-model="filters.selectedStatus">
                <option value="">Статус</option>
                <option value="Отмена">Отмена</option>
                <option value="Срыв">Срыв</option>
                <option value="Отказ">Отказ</option>
              </select>
          </div>
        </div>

        <div class="filter-block">
            <div class="field">
                <!-- Рабочий статус рейса в системе -->
                <work-status-filter v-model="filters.selectWorkStatus" class="input-status"/>
            </div>
            <div class="field">
            <!-- Тип транспорта -->
            <select class="select-transport-type" id="transportType" v-model="filters.selectedTrancportType">
                <option value="">Тип ТС</option>
                <option value="REF">REF</option>
                <option value="TENT">TENT</option>
                <option value="ISO">ISO</option>
            </select>
            </div>
        </div>
        
        <div class="filter-block">
          <div class="field">
            <!-- Открытые -->
            <select class="select-transport-type" id="transportType" v-model="filters.open_trip">
                <option :value="null">Все/Открытые</option>
                <option :value="true">Открытые</option>
            </select>
          </div>
          <div class="field">
            <!-- Топ 8 -->
            <select class="select-transport-type" id="transportType" v-model="filters.is_top">
                <option :value="null">Топ/Все</option>
                <option :value="true">Топ-8</option>
            </select>
          </div>
        </div>

        <div class="filter-block">
          <!-- Даты погрузки/разгрузки -->
          <div class="field">
            <input type="date" pattern="\d{4}-\d{2}-\d{2}" v-model="filters.startDate">
            <!-- <datepicker v-model="filters.startDate" format="yyyy-MM-dd" placeholder="Дата начала" class="datepick-input" utc></datepicker> -->
          </div>
          <div class="field">
            <input type="date" pattern="\d{4}-\d{2}-\d{2}" v-model="filters.endDate">
            <!-- <datepicker v-model="filters.endDate" format="yyyy-MM-dd" placeholder="Дата завершения" class="datepick-input"></datepicker>   -->
          </div>
          
        </div>
        
        
        <div class="filter-block">
          <!-- Города отправления и назначения -->
          <div class="field">
            <input type="text" id="departureCity" list="departureCityList" v-model="filters.selectedDepartureCity" placeholder="Город отправления" @keydown.enter="sendForm">
            <datalist id="departureCityList">
                <option v-for="city in options.trip_city" :key="city" :value="city">{{ city }}</option>
            </datalist>
          </div>

          <div class="field">
            <input type="text" id="destinationCity" list="destinationCityList" v-model="filters.selectedDestinationCity" placeholder="Город доставки" @keydown.enter="sendForm">
            <datalist id="destinationCityList">
                <option v-for="city in options.trip_city" :key="city" :value="city">{{ city }}</option>
            </datalist>
          </div>
  
          
        </div>

        <!-- Кнопки -->
        
      </div>
      <div v-if="isAdmin" class="filter-block resync-block">
        <label class="resync-checkbox">
          <input type="checkbox" v-model="filters.resync_blocked" @change="sendForm">
          <span>Resync-блок</span>
        </label>
      </div>
      <div class="filter-block submit-buttons ">
        <button class="trip-filter-button submit-btn hover" @click="sendForm">Применить</button>
        <button :class="{'trip-filter-button':true,'submit-btn hover':isModified}" @click="submitExel" type="submit" :disabled="!isModified">
            Скачать Excel
            <!-- <font-awesome-icon 
            class="icon" 
            icon="fa-solid fa-file-arrow-down" 
            @click="pageChanged(currentPage)"/> -->
        </button>    
        <button :class="{'trip-filter-button':true,'reset-btn hover':isModified}" @click="resetFilter" :disabled="!isModified">Сброс</button>
      </div>
    </div>
  </template>
  
  <script>
  import { computed,onMounted,watch } from 'vue';
  import { useStore } from 'vuex';
  
  
  export default {
    name: 'FiltersBlockCargos',
    components: {
    //   Datepicker,
    },
    setup() {
      const store = useStore();
  
      onMounted(()=>{
        if (store.getters.isAuthenticated) {
          store.dispatch('apiStorage/getOptions',{model:'options',params:{}})
        }
      })

      watch(
        () => store.getters.isAuthenticated,
        async (newVal) => {
          if (newVal) {
            await store.dispatch('apiStorage/getOptions', { model: 'options', params: {} })
          }
        }
      )
  
      const sendForm = async () => {
        store.commit('cargos/setFiltered',true)
        await store.dispatch('cargos/getCargos',{page:1})
      }
  
      const resetFilter = async () => {
        store.commit('cargos/resetFilters')
        await store.dispatch('cargos/getCargos',{page:1})
      }
  
      return {
        sendForm,
        resetFilter,
        submitExel:async()=>await store.dispatch('cargos/getFile'),
        options:computed(() => store.state.apiStorage.options),
        filters: store.state.cargos.filters.cargolist,
        isModified:computed(()=>store.getters['cargos/isModifyFilter']),
        isAdmin:computed(()=>store.getters.isAdmin),
      };
    },
  };
  </script>
  
  <style scoped>
  .trips-filters {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  
  
  .field{
    margin: 10px;
    border-radius: 3px;
    height: 26px;
  }

  .field input,
  .field select {
    padding: 5px;
    width: 177px;
    border: none;
    border-bottom: 1px solid #ccc;
    background-color: white;
    
  }
  
  .trip-filter-button{
    border-radius: 30px;
    background-color: #fff;
    border: none;
    width: 110px;
    padding: 2px 10px;
  }

  .submit-buttons *{
    margin-left: 10px;
    margin-bottom: 20px;
  }
  .hover:hover{
    cursor: pointer;
  }
  .submit-btn{
    background-color: rgba(195,228,255,0.5);
  }
  .reset-btn{
    background-color: rgba(255,172,172,0.5);
  }

  .resync-block {
    margin-left: auto;
    align-self: center;
  }
  .resync-checkbox {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    user-select: none;
    white-space: nowrap;
    color: #b54747;
    font-weight: 600;
  }
  .resync-checkbox input {
    width: auto;
    cursor: pointer;
    margin: 0;
  }
  </style>
  
  